export const actions = {
    GET_WORKSPACE_DETAILS: 'GET_WORKSPACE_DETAILS',
    UPDATE_WORKSPACE_DETAILS: 'UPDATE_WORKSPACE_DETAILS',
};
